import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const USER_NAME = process.env.REACT_APP_USER_NAME;
const PASSWORD = process.env.REACT_APP_PASSWORD;

const initialState = {
    isLoading: false,
    data: [],
    isError: false,
};

export const fetchRoles = createAsyncThunk('fetchRoles', async () => {
    const response = await fetch(`${API_BASE_URL}/role/list`, {
        method: 'GET',
        headers: { 'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`) }
    });
    return response.json();
});

export const deleteRole = createAsyncThunk('deleteRole', async ({id}, {dispatch}) => {
    const details = {
        'role_id': id,
    };

    let formBody = [];
    for (let property in details) {
    let encodedKey = encodeURIComponent(property);
    let encodedValue = encodeURIComponent(details[property]);
    formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");

    
    const response = await fetch(`${API_BASE_URL}/role/delete`, {
        method: 'POST',
        headers: { 
            'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`),
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: formBody
    });
    dispatch(fetchRoles());
    return response.json(); 
});

const roleSlice = createSlice({
    name: 'role',
    initialState,
    extraReducers: (builder) => {
        builder.addCase(fetchRoles.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchRoles.fulfilled, (state, action) => {
            state.isLoading = false;
            if(action.payload.data) {
                state.data = action.payload.data;
            } else {
                state.isError = true;
            }
        });
        builder.addCase(fetchRoles.rejected, (state, action) => {
            state.isError = true;
            state.isLoading = false;
        })
    }
});

export default roleSlice;